import { RootState } from '../../../store/rootModel';

export function isFormatDataLoaded(state: RootState) {
  const { currency, locale, translations } = state.format;
  return !!currency && !!locale && translations && Object.keys(translations).length > 0;
}
